import React from 'react';
import { get } from 'lodash';

export const ShortUrlField = ({source, record = {} }) => {
    const url = get(record, source);
    return url ? <a href={url}>{url.substring(url.lastIndexOf('/')+1)}</a> : null;
}
